<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <v-col
          class="mb-4"
          v-if="$store.state.userInfo"
        >
          <p class="subheading font-weight-regular" v-if="$store.state.userInfo.readInfo">
            앱 정보 관리: 임서 앱의 제목이나 앱 버전 등 앱의 기본적인 표현 정보에 대해 관리합니다.
          </p>
          <p class="subheading font-weight-regular" v-if="$store.state.userInfo.readWeekly">
            주보 관리: 주보 업로드, 주보 상태 등을 확인할 수 있습니다.
          </p>
          <p class="subheading font-weight-regular" v-if="$store.state.userInfo.readBus">
            셔틀버스 관리: 임마누엘 서울교회에 오가는 셔틀버스 정보를 입력할 수 있습니다. 입력된 대로 앱에 표현 됩니다.
          </p>
          <p class="subheading font-weight-regular" v-if="$store.state.userInfo.readParking">
            주차장 관리: 임마누엘 서울교회 주차장과 주변의 추천 주차장을 입력할 수 있습니다. 입력된 대로 앱에 표현 됩니다.
          </p>
          <p class="subheading font-weight-regular" v-if="$store.state.userInfo.readAuth">
            계정 관리: 임마누엘 서울교회 관리자 페이지에 가입한 유저의 권한을 설정할 수 있습니다.
          </p>
        </v-col>
        <v-col
          class="mb-4"
          v-else
        >
          <p class="unauthorized--text text--primary">권한이 없습니다.</p>
        </v-col>
      </div>
    </div>
  </article>
</template>
<script>
export default {
  name: 'Home'
}
</script>
